import { css } from "@emotion/react";

import { colors } from "@styles";

export const icon = css`
  margin-right: 0.5rem;
  color: ${colors.primary};
`;
